"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.ReactStaticPage = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _HeaderTitle = require("../../components/HeaderTitle");

var _SEO = require("../../seo/components/SEO");

var _Page = require("../../antd/layout/Page");

var _reactStatic = require("react-static");

var _withTracker = require("../../analytics/withTracker");

var _production = require("../../app/production");

var _class;

var ReactStaticPage1 = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(ReactStaticPage1, _Component);

  function ReactStaticPage1(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = ReactStaticPage1.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        seoMetadata = _this$props.seoMetadata,
        path = _this$props.path,
        children = _this$props.children,
        otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["title", "seoMetadata", "path", "children"]);

    var header = _react.default.createElement(_HeaderTitle.HeaderTitle, {
      title: title
    });

    return _react.default.createElement(_Page.Page, (0, _extends2.default)({}, otherProps, {
      header: header
    }), _react.default.createElement(_SEO.SEO, {
      title: title,
      seoMetadata: seoMetadata,
      urlPath: path,
      Head: _reactStatic.Head
    }), children);
  };

  return ReactStaticPage1;
}(_react.Component)) || _class;

var ReactStaticPage = (0, _production.isProduction)() ? (0, _withTracker.withTracker)(ReactStaticPage1) : ReactStaticPage1;
exports.ReactStaticPage = ReactStaticPage;